import React, { useState, useEffect } from "react";
import { FaPlus } from "react-icons/fa";
import { FaMinus } from "react-icons/fa";
import Dropdown from "react-bootstrap/Dropdown";
import { toast } from "react-toastify";
import reddelete from "../../images/red-Delete.svg";
import { Autocomplete, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import {
  getQuestions,
  addQuestion,
  updateQuestion,
} from "../services/providerService";

import { Link, useLocation, useNavigate } from "react-router-dom";
import editicon from "../../images/edit-icon.svg";
import binicon from "../../images/bin-icon.svg";
import eyeimg from "../../images/eye.svg";
import plusIcon from "../../images/plusIcon.svg";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import CustomPagination from "../../Common/Component/CustomPagination/CustomPagination";
import "./surveyList.css";
import Loader from "../../utils/Loader";
import BackButton from "../../utils/BackButton";


function QuestionList() {
  const userdata = useSelector((state) => state);
  const location = useLocation();

  const { survey } = location.state || {};
  const navigate = useNavigate();
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [editData, setEditData] = useState(null);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [questionList, setQuestionList] = useState([]);
  const dispatch = useDispatch();
  const token = useSelector((state) => state?.login?.data?.accessToken);
  const [selectedSortValue, setSelectedSortValue] = useState("");
  const { data } = useSelector((state) => state.login);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!survey) {
       data.role === "DOCTOR" && navigate("/doctor/dashboard");
       data.role === "ADMIN" && navigate("/admin/dashboard");
      return;
    }
    _getQuestionList();
  }, [page, limit]);

  const _getQuestionList = async (searchText, sortby) => {
    setLoading(true);
    const respose = await getQuestions({
      page: page + 1,
      limit,
      searchKey: searchText,
      sortBy: sortby,
      surveyId: survey?._id,
    });

 
    if (respose?.status === "SUCCESS") {
      setQuestionList(respose?.data?.list);
      setTotalPages(respose?.data?.totalPages || 0);
      setTotalItems(respose?.data?.totalItems || 0);
    }
    setLoading(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handelDeleteModel = (data) => {
    setEditData(data);
    setDeleteModelShow(true);
  };

  const deleteQuestion = async () => {
    const updateData = {
      _id: editData._id,
      isDelete: true,
    };
    await updateQuestion(updateData);
    _getQuestionList(searchText, selectedSortValue);
    setDeleteModelShow(false);
  };

  const handleSelect = (eventKey) => {

    setSelectedSortValue(eventKey); // Update the state with the selected value
    _getQuestionList(searchText, eventKey);
  };

  // *********************************** Handle model pop up *************************************************************
  const [show, setShow] = useState(false);
  const [showViewModel, setShowViewModel] = useState(false);
  const [deleteModelShow, setDeleteModelShow] = React.useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // ************************************** Handle question select type **********************************************************************************
  const [formData, setFormData] = useState({
    surveyId: survey?._id,
    text: "",
    type: "",
    options: [],
    isRequired: false,
    isActive: true,
  });

  const [questionType, setQuestionType] = useState("");
  const [options, setOptions] = useState([""]);

  // Handle change for the question text input
  const handleTextChange = (e) => {
    const value = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      text: value,
    }));
  };

  // Handle change for the question type dropdown
  const handleQuestionTypeChange = (event, value) => {
    setQuestionType(value);
    setOptions([""]);
    setFormData((prevData) => ({
      ...prevData,
      type: value,
      options: [],
      updatedAt: new Date(),
    }));
  };

  // Handle adding a new option
  const addOption = () => {
    setOptions([...options, ""]);
  };

  // Handle removing an option
  const removeOption = (index) => {
    const updatedOptions = options.filter((_, i) => i !== index);
    setOptions(updatedOptions);
  };

  // Handle option change for each option input
  const handleOptionChange = (index, value) => {
    const updatedOptions = options.map((option, i) =>
      i === index ? value : option
    );
    setOptions(updatedOptions);
    setFormData((prevData) => ({
      ...prevData,
      options: updatedOptions,
      updatedAt: new Date(),
    }));
  };

  const handleEdit = (data) => {
  
    setShow(true);
    setEditData(data);
    setQuestionType(data.type);
    setOptions(data.options);
    setFormData({
      surveyId: data.surveyId,
      text: data.text,
      type: data.type,
      options: data.options,
      isRequired: data.isRequired,
      isActive: data.isActive,
    });
  };

  const handleView = (data) => {
    setShowViewModel(true);
    setQuestionType(data.type);
    setOptions(data.options);
    setFormData({
      surveyId: data.surveyId,
      text: data.text,
      type: data.type,
      options: data.options,
      isRequired: data.isRequired,
      isActive: data.isActive,
    });
  };

  // Handle the form submission (Add/Update Question)
  const handleSubmit = async () => {
    if (formData.text === "" || formData.type === "") {
      toast.info("Please fill out all required fields.");  // Optional: Show a message to the user
      return;
    }
    setLoading(true)
  
    if (editData) {
     
      await updateQuestion({ ...formData, _id: editData._id });
    } else {
      // Add new question
      await addQuestion(formData);
    }
    setLoading(false)

    _getQuestionList(searchText, selectedSortValue);

    handleClose();
  };
  
  return (
    <div className="Dashboard-wrapper">
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="add-doctor">
            <Form className="d-flex gap-3 align-items-center ">
              {/* <ArrowDown className="rotated-arrow"/>
               */}
               <BackButton path=  {data.role === "ADMIN" ? "/admin/survey/survey-list" :"/doctor/survey/survey-list" }/>
              <p className="text-capitalize fs-4 mb-0">{survey?.title}</p>
            </Form>
<div className="add_ques_btns d-flex align-items-center gap-2">
<Button
              className="filled-btn"
              onClick={() => {
                setEditData(null);

                handleShow();
                setFormData({
                  surveyId: survey?._id,
                  text: "",
                  type: "",
                  options: [],
                  isRequired: false,
                  isActive: false,
                });
                setQuestionType("");
                setOptions([""]);
              }}
            >
              <img className="filled-btn" src={plusIcon} />
            </Button>
            <p className="mb-0">Add Question</p>
</div>
           

            {/* Button to trigger modal */}

            <Dropdown
              className="patient-info-dropdown "
              onSelect={handleSelect}
            >
              <Dropdown.Toggle className="db-dropdown h-100 ">
                {selectedSortValue === ""
                  ? "Sort By"
                  : selectedSortValue === "name-asc"
                  ? "Name A-Z"
                  : "Name Z-A"}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item eventKey="">Default</Dropdown.Item>
                <Dropdown.Item eventKey="name-asc">Name A-Z</Dropdown.Item>
                <Dropdown.Item eventKey="name-dsc">Name Z-A</Dropdown.Item>
                
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <div className="table-responsive dashboard-table">
            <table className="patients-table">
              <thead>
                <tr className="t-row-block">
                  <th scope="col">Sr No</th>
                  <th scope="col">Question</th>
                  <th scope="col">Category</th>
                  <th scope="col">Status</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                {questionList.length > 0 ? (
                  questionList.map((question, index) => (
                    <tr key={question.id || index}>
                      <td scope="row">{++index}</td>
                      <td>
                        <div className="d-flex align-items-center gap-2 text-capitalize ">
                          {question?.text ? question?.text : "-"}{" "}
                        </div>
                      </td>

                      <td>{question?.type ? question?.type : "-"}</td>

                      <td>
                        <span
                          className={`survey-status ${
                            question?.isActive
                              ? "survey-active-btn"
                              : "survey-inactive-btn"
                          }`}
                        >
                          {question?.isActive ? "Active" : "Inactive"}
                        </span>
                      </td>

                      <td>
                        
                        <div className="d-flex gap-2">
                          <a
                            className="edit-del-icon eye-edit-del eye-img"
                            onClick={() => {
                              handleView(question);
                            }}
                          >
                            <img src={eyeimg} alt="view" />
                          </a>
                          <a
                            className="edit-del-icon eye-edit-del edit-img"
                            onClick={() => {
                              handleEdit(question);
                            }}
                          >
                            <img src={editicon} alt="edit" />
                          </a>
                          <a
                            className="edit-del-icon eye-edit-del del-img"
                            onClick={() => handelDeleteModel(question)}
                          >
                            <img src={binicon} alt="delete" />
                          </a>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No question Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* Modal */}
      {/* Modal to edit and add  */}
      <Modal
        className="survey-model"
        show={show}
        onHide={handleClose}
        centered
        style={{ borderRadius: "20px" }}
      >
        <Modal.Header
          className="header"
          style={{ borderTopLeftRadius: "20px", borderTopRightRadius: "20px" }}
        >
          <Modal.Title>
            {" "}
            {editData ? "Update Question" : "Add Question"}
          </Modal.Title>
          <button
            type="button"
            className="close-btn mr-0"
            onClick={handleClose}
          ></button>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div className="form-control-area">
            <Form.Group
              className="mb-4 text-start"
              controlId="exampleForm.ControlInputFirstName"
            >
              <Form.Label className="details">
                Question<span className="asterisk">*</span>
              </Form.Label>
              <div className="row align-items-center">
                <div className="col-8">
                  <Form.Control
                    type="text"
                    placeholder="Write Question here..."
                    value={formData.text}
                    onChange={handleTextChange}
                  />
                </div>
                <div className="col-4">
                  <Form.Check
                    className="add_ques-checkbox d-flex align-items-center gap-3"
                    label="Is Required"
                    checked={formData.isRequired}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        isRequired: e.target.checked,
                      })
                    }
                  />
                </div>
              </div>
            </Form.Group>

            <Form.Group
              className="mb-4 text-start"
              controlId="exampleForm.ControlSelectNationality"
            >
              <Form.Label className="details">
                Question Type<span className="asterisk">*</span>
              </Form.Label>
              <div className="row align-items-center">
                <div className="col-8">
                  <Autocomplete
                    id="question-type-autocomplete"
                    options={[
                      "Short Answer",
                      "Long Answer",
                      "Single Choice",
                      "Multiple Choice",
                      "Dropdown",
                      "Star Rating",
                     
                     
                    ]}
                    onChange={handleQuestionTypeChange}
                    value={questionType}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select Question Type"
                        variant="outlined"
                      />
                    )}
                  />
                </div>

                <div className="col-4">
                  <Form.Check
                    className="add_ques-checkbox d-flex align-items-center gap-3"
                    label="Is Active"
                    checked={formData.isActive}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        isActive: e.target.checked,
                      })
                    }
                  />
                </div>
              </div>
            </Form.Group>

          
            {(questionType === "Single Choice" ||
              questionType === "Multiple Choice" ||  questionType === "Dropdown"  ) && (
              <div className="mb-3">
               
                {options.map((option, index) => (
  <div key={index} className="d-flex mb-2 ">
    
    <input
      type="text"
      className="form-control "
      placeholder={`Option ${index + 1}`}
      value={option}
      onChange={(e) => handleOptionChange(index, e.target.value)}
    />
    
    {/* If it's the last option, show "Add Option" button */}
    {index === options.length - 1 ? (
      <button
        className="btn mx-2 btn-outline"
        onClick={addOption}
      >
        <FaPlus/>
      </button>
    ) : (
      // Otherwise, show "Remove" button for all previous options
      <button
        type="button"
        className="btn mx-2"
        onClick={() => removeOption(index)}
      >
        <FaMinus/>
      </button>
    )}
  </div>
))}
              </div>
            )}
          </div>

          <div className="d-flex gap-4 justify-content-end">
            <Button className="btn btn-primary outlined-btn" onClick={handleClose}>
              Cancel
            </Button>
            <Button disabled = {loading} className="btn btn-primary filled-btn" onClick={handleSubmit}>
              {editData ? "Update" : "Add"}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Modal to view  */}

      <Modal
        className="survey-model"
        show={showViewModel}
        onHide={handleClose}
        centered
        style={{ borderRadius: "20px" }}
      >
        <Modal.Header
          className="header"
          style={{ borderTopLeftRadius: "20px", borderTopRightRadius: "20px" }}
        >
          <Modal.Title> View Question </Modal.Title>
          <button
            type="button"
            className="close-btn mr-0"
            onClick={handleClose}
          ></button>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div className="form-control-area">
            <Form.Group
              className="mb-4 text-start"
              controlId="exampleForm.ControlInputFirstName"
            >
              <Form.Label className="details">
                Question<span className="asterisk">*</span>
              </Form.Label>
              <div className="row">
                <div className="col-8">
                  <Form.Control
                    type="text"
                    placeholder="Write Question here..."
                    value={formData.text}
                    // onChange={handleTextChange}
                  />
                </div>
                <div className="col-3">
                  <Form.Check
                    className=""
                    label="Is Required"
                    checked={formData.isRequired}
                  />
                </div>
              </div>
            </Form.Group>

            <Form.Group
              className="mb-3 text-start"
              controlId="exampleForm.ControlSelectNationality"
            >
              <Form.Label className="details">
                Question Type<span className="asterisk">*</span>
              </Form.Label>
              <div className="row">
                <div className="col-8">
                  <Form.Control
                    type="text"
                    placeholder="Write Question here..."
                    value={questionType}
                   
                  />
                </div>

                <div className="col-3">
                  <Form.Check
                    className=""
                    label="Is Active"
                    checked={formData.isActive}
                  />
                </div>
              </div>
            </Form.Group>

            {/* Display options fields if the selected question type is Single or Multiple Choice */}
            {(questionType === "Single Choice" ||
              questionType === "Multiple Choice" ||  questionType === "Dropdown") && (
              <div className="mb-3">
                <label>Options:</label>
                {options.map((option, index) => (
                  <div key={index} className="d-flex mb-2">
                    <input
                      type="text"
                      className="form-control"
                      placeholder={`Option ${index + 1}`}
                      value={option}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="d-flex gap-4 justify-content-end">
            <Button
              className="btn btn-primary outlined-btn"
              onClick={() => setShowViewModel(false)}
            >
              Cancel
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* delete survey modal */}
      <Modal
        className="dlt-patient-modal"
        show={deleteModelShow}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setDeleteModelShow(false)}
      >
        <Modal.Body>
          <div className="d-flex justify-content-center mb-3">
            <div className="delete-img">
              <img src={reddelete} alt="img"></img>
            </div>
          </div>
          <h4>Are you sure? </h4>
          <p>You want to detele this question</p>
          <div className="authentication-btns d-flex justify-content-center gap-4">
            <Button
              className="btn border-btn btn-no outlined-btn"
              onClick={() => setDeleteModelShow(false)}
            >
              No
            </Button>
            <Button
              className="btn dark-btn btn-yes"
              onClick={() => deleteQuestion()}
            >
              Yes
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <div className="pagination-blk">
        <CustomPagination
          totalItems={totalItems}
          page={page}
          onPageChange={handleChangePage}
          limit={limit}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </div>
  );
}

export default QuestionList;
